import { useMutation } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'

type ReservationResult = {
  linkConnect: string
}

export const useEtestingReservation = () =>
  useMutation<ReservationResult, Error, number[]>({
    mutationFn: (applicantIds) =>
      fetchApiWithToken<ReservationResult>({
        method: 'post',
        url: '/v1/extensions/etesting/reservations',
        data: { applicantIds }
      })
  })
